import { Box, Container } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Components/Header';
import { HeaderControlContextProvider } from './Contexts/HeaderControlContext';

/**
 * The articles view
 */
const ArticlesView = () => {
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [useTitleH2, setUseTitleH2] = useState(true);

  /**
   * Reset the titles back to the defaults
   */
  const resetTitles = useCallback(() => {
    setUseTitleH2(true);
    setTitle('Learn from the experts');
    setSubTitle('S3G Security Articles');
  }, []);

  useEffect(() => {
    resetTitles();
  }, [resetTitles]);

  return (
    <Box width="100%" height="100%">
      <Header title={title} subtitle={subTitle} useTitleH2={useTitleH2} />
      <Container maxWidth="md" sx={{ paddingBottom: '.5em' }}>
        <HeaderControlContextProvider
          setSubtitle={setSubTitle}
          setTitle={setTitle}
          setUseTitleH2={setUseTitleH2}
          resetTitle={resetTitles}
        >
          <Outlet />
        </HeaderControlContextProvider>
      </Container>
    </Box>
  );
};

export default ArticlesView;
